import view from '../../Enums';
import * as IMAGES from '../../Images';
import { makeStyle } from '../../utils';

var BecomeAnOyoStyles = {};

var vertCenterAbs = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)'
};
var horiCenterAbs = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)'
};

var centerAbs = {
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translateY(-50%) translateX(-50%)'
};

export var centerAbs;

// Screen 1 styles
let key;
let commonStyle;

key = '';
BecomeAnOyoStyles[key] = {};
BecomeAnOyoStyles[key][view.MOBILE] = {};
BecomeAnOyoStyles[key][view.DESKTOP] = {};

key = 'formMain';
commonStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  boxShadow: '0 3px 4px 0 rgba(157, 157, 157, 0.14)',
  border: 'solid 0.5px rgba(0, 0, 0, 0.1)',
  height: '280px'
};
BecomeAnOyoStyles[key] = {};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...commonStyle,
  width: '320px',
  position: 'absolute',
  bottom: '0',
  transform: 'translateY(50%) translateX(-50%)',
  left: '50%',
  padding: '10px 18px 3px 18px'
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...commonStyle,
  ...vertCenterAbs,
  width: '380px',
  padding: '10px 18px 3px 18px'
};

let bigTextFormStyle = {
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '-0.23px',
  color: 'rgb(34, 34, 34)'
};

key = 'big_text_form';
BecomeAnOyoStyles[key] = {};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...bigTextFormStyle,
  fontSize: '16px',
  marginBottom: '8px',
  display:'inline'
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...bigTextFormStyle,
  fontSize: '20px',
  marginBottom: '10px',
  display:'inline'
};

let inputHeadStyle = {
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: 'rgb(136, 136, 136)'
};

key = 'input_head_city';
BecomeAnOyoStyles[key] = {};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...inputHeadStyle,
  fontSize: '12px'
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...inputHeadStyle,
  fontSize: '12px'
};

BecomeAnOyoStyles['location_container'] = {};
BecomeAnOyoStyles['location_container'][view.MOBILE] = {
  position: 'relative'
};
BecomeAnOyoStyles['location_container'][view.DESKTOP] = {
  position: 'relative'
};

BecomeAnOyoStyles['form_small_text'] = {};
BecomeAnOyoStyles['form_small_text'][view.MOBILE] = {
  height: '24px',
  opacity: '0.54',
  fontSize: '12px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: '#222222'
};
BecomeAnOyoStyles['form_small_text'][view.DESKTOP] = {
  fontSize: '12px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: '#888'
};

BecomeAnOyoStyles['input_form'] = {};
commonStyle = {
  borderRadius: '2px',
  border: 'solid 1px rgba(0, 0, 0, 0.08)',
  padding: '10px 0px 10px 16px',
  width: '95%',
  marginBottom: '10px',
  marginTop: '3px',
  fontSize: '16px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000'
};
BecomeAnOyoStyles['input_form'][view.MOBILE] = {
  ...commonStyle
};
BecomeAnOyoStyles['input_form'][view.DESKTOP] = {
  ...commonStyle
};

key = 'big_green_button';
commonStyle = {
  borderRadius: '4px',
  border: '0px',
  boxShadow: 'rgba(26, 182, 79, 0.2) 0px 4px 8px 0px',
  backgroundColor: 'rgb(26, 182, 79)',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: 'rgb(255, 255, 255)',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  textTransform: 'uppercase'
};
BecomeAnOyoStyles[key] = {};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...commonStyle,
  height: '44px'
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...commonStyle,
  height: '44px'
};

key = 'bottom_container_form';
commonStyle = {
  position: 'absolute',
  left: '3px',
  right: '3px',
  bottom: '10px'
};
BecomeAnOyoStyles[key] = {};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...commonStyle,
  height: '44px'
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...commonStyle,
  height: '44px'
};

BecomeAnOyoStyles['mobile_number_container'] = {};
BecomeAnOyoStyles['mobile_number_container'][view.MOBILE] = {
  width: '92%',
  position: 'relative'
};
BecomeAnOyoStyles['mobile_number_container'][view.DESKTOP] = {
  position: 'relative'
};

BecomeAnOyoStyles['cursor_pointer_style'] = {};
BecomeAnOyoStyles['cursor_pointer_style'][view.MOBILE] = {
  position: 'absolute',
  top: '16px',
  left: '46px'
};
BecomeAnOyoStyles['cursor_pointer_style'][view.DESKTOP] = {
  position: 'absolute',
  top: '16px',
  left: '46px'
};

BecomeAnOyoStyles['down_arrow_style'] = {};
BecomeAnOyoStyles['down_arrow_style'][view.MOBILE] = {
  height: '10px',
  width: '12px'
};
BecomeAnOyoStyles['down_arrow_style'][view.DESKTOP] = {
  height: '10px',
  width: '12px'
};

BecomeAnOyoStyles['flag_image_style'] = {};
BecomeAnOyoStyles['flag_image_style'][view.MOBILE] = {
  position: 'absolute',
  top: '19.5px',
  left: '18px'
};
BecomeAnOyoStyles['flag_image_style'][view.DESKTOP] = {
  position: 'absolute',
  top: '19.5px',
  left: '18px'
};

BecomeAnOyoStyles['flag_style'] = {};
commonStyle = {
  top: '13px',
  width: '24px',
  height: '14.6px',
  backgroundImage: 'url(' + IMAGES.FLAGS + ')',
  backgroundPosition: '100 100',
  backgroundSize: 'cover',
  position: 'relative',
  zIndex: '2',
  display: 'inline-block',
  cursor: 'pointer'
};
BecomeAnOyoStyles['flag_style'][view.MOBILE] = {
  ...commonStyle
};
BecomeAnOyoStyles['flag_style'][view.DESKTOP] = {
  ...commonStyle
};

BecomeAnOyoStyles['mobile_number_container'] = {};
BecomeAnOyoStyles['mobile_number_container'][view.MOBILE] = {
  width: '92%',
  position: 'relative'
};
BecomeAnOyoStyles['mobile_number_container'][view.DESKTOP] = {
  position: 'relative'
};

key = 'flagImage';
commonStyle = {
  width: '24px',
  height: '14.6px',
  backgroundImage: 'url(' + IMAGES.FLAGS + ')',
  backgroundPosition: '100 100',
  backgroundSize: 'cover',
  position: 'relative',
  display: 'inline-block',
  cursor: 'pointer',
  margin: '0px 6px',
  top: '2.5px'
};
BecomeAnOyoStyles[key] = {};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...commonStyle
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...commonStyle
};

key = 'bottom_nav';
BecomeAnOyoStyles[key] = {};
commonStyle = {
  position: 'absolute',
  bottom: '0px'
};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...commonStyle,
  fontSize: '8px'
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...commonStyle,
  fontSize: '10px'
};

key = 'blue_bold';
BecomeAnOyoStyles[key] = {};
commonStyle = {
  fontFamily: 'InterphaseBold',
  color: 'blue'
};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...commonStyle,
  fontSize: '8px'
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...commonStyle,
  fontSize: '10px'
};

key = 'botom_nav_form';
BecomeAnOyoStyles[key] = {};
commonStyle = {
  marginBottom: '3px'
};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...commonStyle
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...commonStyle
};

key = 'otp_input';
BecomeAnOyoStyles[key] = {};
commonStyle = {
  boxShadow: '1px 1px #ddd'
};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...commonStyle,
  height: '25px',
  width: '25px',
  fontSize: '12px'
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...commonStyle,
  fontSize: '14px',
  height: '40px',
  width: '40px'
};

key = 'img_form_down_dropdown';
BecomeAnOyoStyles[key] = {};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...vertCenterAbs,
  right: '15px'
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...vertCenterAbs,
  right: '15px'
};

key = 'dropdown_child';
BecomeAnOyoStyles[key] = {};
BecomeAnOyoStyles[key][view.MOBILE] = {
  ...vertCenterAbs,
  left: '15px'
};
BecomeAnOyoStyles[key][view.DESKTOP] = {
  ...vertCenterAbs,
  left: '15px'
};

BecomeAnOyoStyles['back'] = makeStyle({cursor:'pointer'},{
  height:'15px',width:'14px',margin:'2px 8px -1px 0px'
},view.DESKTOP,{
  margin:'2px 9px -2px 0px',height:'18px',width:'18px'
});
key = 'big_white_button';
commonStyle = {
  ...BecomeAnOyoStyles['big_green_button'][view.DESKTOP],
  cursor : 'pointer',
  textTransform: 'none',
  boxShadow: 'none',
  border: '1px solid #888',
  backgroundColor: 'none',
  color: '#888',
  
};
BecomeAnOyoStyles[key] = makeStyle(commonStyle,{},{},{});

key = 'or';
commonStyle = {
  position: 'relative',
  textAlign:'center',
  margin:'8px 0',
  color:'#888'
};
BecomeAnOyoStyles[key] =  makeStyle(commonStyle,{},{},{});

BecomeAnOyoStyles['pwd_container'] = makeStyle({position : 'relative'},{},{},{width:'98%'});
key = 'suucessful_sign_up';
commonStyle = {
  position : 'relative',
  marginTop: '8px',
  color: 'green',
  fontWeight: 'bold',
  fontSize: '14px',
  textAlign: 'center',
};
BecomeAnOyoStyles[key] = makeStyle(commonStyle,{},{},{});
export default BecomeAnOyoStyles;
